/* eslint-disable import/prefer-default-export */
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ExplanationTooltip = ({ content }: { content: React.ReactNode }) => {
  const { t } = useTranslation()
  return (
    <>
      {content}
      <br />
      {t('clickHelpMoreInfo')}
    </>
  )
}
